import { api_GET, api_POST, api_PUT } from './_api';

const mapasService_api = {
    PontosDeColeta: (filtros) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Mapa/PontosDeColeta`, filtros)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    ColetasEfetuadas: (filtros) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Mapa/ColetasEfetuadas`, filtros)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    ColetasProgramadas: (filtros) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Mapa/ColetasProgramadas`, filtros)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    MapaFiscalizacao: (filtros) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Mapa/MapaFiscalizacao`, filtros)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GeradoresComEndereco: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Mapa/GeradoresComEndereco/`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    MapaTermico: (filtros) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Mapa/MapaTermico/`, filtros)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
}
export default mapasService_api;